var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-font',{attrs:{"type":_vm.type},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }